var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"black",attrs:{"fluid":""}},[(!_vm.isCheckout)?_c('footer-address'):_vm._e(),(!_vm.isCheckout)?_c('Links'):_vm._e(),_c('copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }